/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminOvertimeWeeksListParams,
  AdminOvertimeWeeksRetrieveParams,
  ConflictError,
  CustomValidationError,
  InvoicedCustomerId,
  InvoicedCustomerIdUpdateRequest,
  InvoicingCustomer,
  NotFoundError,
  PaginatedProWorkWeekList,
  Payment,
  PaymentRequest,
  PaymentsInvoicingCustomerRetrieveParams,
  PaymentsInvoicingCustomerUpdateParams,
  PermissionDeniedError,
  ProWorkWeek,
  UnauthenticatedError,
  ValidationError
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getAdminOvertimeWeeksListUrl = (params?: AdminOvertimeWeeksListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/overtime/weeks/?${stringifiedParams}` : `/api/admin/overtime/weeks/`
}

/**
 * Paginated California overtime ledger, one row per pro-week. Newest week first. Hours are decimal hours, rounded to the hundredth. Money fields are decimal strings. With `?format=csv` the same rows stream as CSV without pagination or `allocations`.
 * @summary List pro overtime weeks.
 */
export const adminOvertimeWeeksList = async (params?: AdminOvertimeWeeksListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedProWorkWeekList | string> => {

  return customFetch<PaginatedProWorkWeekList | string>(getAdminOvertimeWeeksListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminOvertimeWeeksListInfiniteQueryKey = (params?: AdminOvertimeWeeksListParams,) => {
    return [
    'infinite', `/api/admin/overtime/weeks/`, ...(params ? [params] : [])
    ] as const;
    }

export const getAdminOvertimeWeeksListQueryKey = (params?: AdminOvertimeWeeksListParams,) => {
    return [
    `/api/admin/overtime/weeks/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminOvertimeWeeksListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof adminOvertimeWeeksList>>, AdminOvertimeWeeksListParams['page']>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(params?: AdminOvertimeWeeksListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminOvertimeWeeksList>>, TError, TData, QueryKey, AdminOvertimeWeeksListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminOvertimeWeeksListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminOvertimeWeeksList>>, QueryKey, AdminOvertimeWeeksListParams['page']> = ({ signal, pageParam }) => adminOvertimeWeeksList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminOvertimeWeeksList>>, TError, TData, QueryKey, AdminOvertimeWeeksListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminOvertimeWeeksListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminOvertimeWeeksList>>>
export type AdminOvertimeWeeksListInfiniteQueryError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError


export function useAdminOvertimeWeeksListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminOvertimeWeeksList>>, AdminOvertimeWeeksListParams['page']>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 params: undefined |  AdminOvertimeWeeksListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminOvertimeWeeksList>>, TError, TData, QueryKey, AdminOvertimeWeeksListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOvertimeWeeksList>>,
          TError,
          Awaited<ReturnType<typeof adminOvertimeWeeksList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOvertimeWeeksListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminOvertimeWeeksList>>, AdminOvertimeWeeksListParams['page']>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 params?: AdminOvertimeWeeksListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminOvertimeWeeksList>>, TError, TData, QueryKey, AdminOvertimeWeeksListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOvertimeWeeksList>>,
          TError,
          Awaited<ReturnType<typeof adminOvertimeWeeksList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOvertimeWeeksListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminOvertimeWeeksList>>, AdminOvertimeWeeksListParams['page']>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 params?: AdminOvertimeWeeksListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminOvertimeWeeksList>>, TError, TData, QueryKey, AdminOvertimeWeeksListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List pro overtime weeks.
 */

export function useAdminOvertimeWeeksListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminOvertimeWeeksList>>, AdminOvertimeWeeksListParams['page']>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 params?: AdminOvertimeWeeksListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminOvertimeWeeksList>>, TError, TData, QueryKey, AdminOvertimeWeeksListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminOvertimeWeeksListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminOvertimeWeeksListQueryOptions = <TData = Awaited<ReturnType<typeof adminOvertimeWeeksList>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(params?: AdminOvertimeWeeksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOvertimeWeeksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminOvertimeWeeksListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminOvertimeWeeksList>>> = ({ signal }) => adminOvertimeWeeksList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminOvertimeWeeksList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminOvertimeWeeksListQueryResult = NonNullable<Awaited<ReturnType<typeof adminOvertimeWeeksList>>>
export type AdminOvertimeWeeksListQueryError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError


export function useAdminOvertimeWeeksList<TData = Awaited<ReturnType<typeof adminOvertimeWeeksList>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 params: undefined |  AdminOvertimeWeeksListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOvertimeWeeksList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOvertimeWeeksList>>,
          TError,
          Awaited<ReturnType<typeof adminOvertimeWeeksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOvertimeWeeksList<TData = Awaited<ReturnType<typeof adminOvertimeWeeksList>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 params?: AdminOvertimeWeeksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOvertimeWeeksList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOvertimeWeeksList>>,
          TError,
          Awaited<ReturnType<typeof adminOvertimeWeeksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOvertimeWeeksList<TData = Awaited<ReturnType<typeof adminOvertimeWeeksList>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 params?: AdminOvertimeWeeksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOvertimeWeeksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List pro overtime weeks.
 */

export function useAdminOvertimeWeeksList<TData = Awaited<ReturnType<typeof adminOvertimeWeeksList>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 params?: AdminOvertimeWeeksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOvertimeWeeksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminOvertimeWeeksListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminOvertimeWeeksRetrieveUrl = (id: number,
    params?: AdminOvertimeWeeksRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/overtime/weeks/${id}/?${stringifiedParams}` : `/api/admin/overtime/weeks/${id}/`
}

/**
 * One pro-week with its per-shift `allocations`. Accepts the list filters. `business_id` narrows `allocations` the same way it does on the list.
 * @summary Retrieve one pro overtime week.
 */
export const adminOvertimeWeeksRetrieve = async (id: number,
    params?: AdminOvertimeWeeksRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<ProWorkWeek> => {

  return customFetch<ProWorkWeek>(getAdminOvertimeWeeksRetrieveUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminOvertimeWeeksRetrieveQueryKey = (id: number,
    params?: AdminOvertimeWeeksRetrieveParams,) => {
    return [
    `/api/admin/overtime/weeks/${id}/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminOvertimeWeeksRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminOvertimeWeeksRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(id: number,
    params?: AdminOvertimeWeeksRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOvertimeWeeksRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminOvertimeWeeksRetrieveQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminOvertimeWeeksRetrieve>>> = ({ signal }) => adminOvertimeWeeksRetrieve(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminOvertimeWeeksRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminOvertimeWeeksRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminOvertimeWeeksRetrieve>>>
export type AdminOvertimeWeeksRetrieveQueryError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError


export function useAdminOvertimeWeeksRetrieve<TData = Awaited<ReturnType<typeof adminOvertimeWeeksRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 id: number,
    params: undefined |  AdminOvertimeWeeksRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOvertimeWeeksRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOvertimeWeeksRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminOvertimeWeeksRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOvertimeWeeksRetrieve<TData = Awaited<ReturnType<typeof adminOvertimeWeeksRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 id: number,
    params?: AdminOvertimeWeeksRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOvertimeWeeksRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOvertimeWeeksRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminOvertimeWeeksRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOvertimeWeeksRetrieve<TData = Awaited<ReturnType<typeof adminOvertimeWeeksRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 id: number,
    params?: AdminOvertimeWeeksRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOvertimeWeeksRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve one pro overtime week.
 */

export function useAdminOvertimeWeeksRetrieve<TData = Awaited<ReturnType<typeof adminOvertimeWeeksRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 id: number,
    params?: AdminOvertimeWeeksRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOvertimeWeeksRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminOvertimeWeeksRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPaymentsListUrl = () => {




  return `/api/payments/`
}

/**
 * Authorization for this action resolves from an `application_id` in the request body, so a request without one is refused with 403. Reading payments without naming an application is not supported.
 */
export const paymentsList = async ( options?: Parameters<typeof customFetch>[1]): Promise<Payment[]> => {

  return customFetch<Payment[]>(getPaymentsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPaymentsListQueryKey = () => {
    return [
    `/api/payments/`
    ] as const;
    }


export const getPaymentsListQueryOptions = <TData = Awaited<ReturnType<typeof paymentsList>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPaymentsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof paymentsList>>> = ({ signal }) => paymentsList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof paymentsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PaymentsListQueryResult = NonNullable<Awaited<ReturnType<typeof paymentsList>>>
export type PaymentsListQueryError = void


export function usePaymentsList<TData = Awaited<ReturnType<typeof paymentsList>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof paymentsList>>,
          TError,
          Awaited<ReturnType<typeof paymentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentsList<TData = Awaited<ReturnType<typeof paymentsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof paymentsList>>,
          TError,
          Awaited<ReturnType<typeof paymentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentsList<TData = Awaited<ReturnType<typeof paymentsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePaymentsList<TData = Awaited<ReturnType<typeof paymentsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPaymentsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPaymentsCreateUrl = () => {




  return `/api/payments/`
}

/**
 * Apply this mixin to any view or viewset to perform the "block pro" flow.
 * It needs the block_pro_data field of type GigsterBlockSerializer declared in the main serializer of the View
 * or Viewset.
 * Also the View or Viewset need to add the BlockProPermission permission in its permission_classes property.
 */
export const paymentsCreate = async (paymentRequest: PaymentRequest, options?: Parameters<typeof customFetch>[1]): Promise<Payment> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Payment>(getPaymentsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(paymentRequest)
  }
);}





export const getPaymentsCreateMutationKey = () => ['paymentsCreate'] as const;

export const getPaymentsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentsCreate>>, TError,PaymentsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof paymentsCreate>>, TError,PaymentsCreateMutationVariables, TContext> => {

const mutationKey = getPaymentsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof paymentsCreate>>, PaymentsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  paymentsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PaymentsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof paymentsCreate>>>
    export type PaymentsCreateMutationBody = PaymentRequest
    export type PaymentsCreateMutationError = void
    export type PaymentsCreateMutationVariables = {data: PaymentRequest}

    export const usePaymentsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentsCreate>>, TError,PaymentsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof paymentsCreate>>,
        TError,
        PaymentsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getPaymentsCreateMutationOptions(options), queryClient);
    }
    export const getPaymentsRetrieveUrl = (id: number,) => {




  return `/api/payments/${id}/`
}

/**
 * Authorization for this action resolves from an `application_id` in the request body, so a request without one is refused with 403. Reading payments without naming an application is not supported.
 */
export const paymentsRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<Payment> => {

  return customFetch<Payment>(getPaymentsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPaymentsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/payments/${id}/`
    ] as const;
    }


export const getPaymentsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof paymentsRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPaymentsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof paymentsRetrieve>>> = ({ signal }) => paymentsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof paymentsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PaymentsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof paymentsRetrieve>>>
export type PaymentsRetrieveQueryError = void


export function usePaymentsRetrieve<TData = Awaited<ReturnType<typeof paymentsRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof paymentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof paymentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentsRetrieve<TData = Awaited<ReturnType<typeof paymentsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof paymentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof paymentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentsRetrieve<TData = Awaited<ReturnType<typeof paymentsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePaymentsRetrieve<TData = Awaited<ReturnType<typeof paymentsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPaymentsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPaymentsInvoicingCustomerRetrieveUrl = (params?: PaymentsInvoicingCustomerRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/payments/invoicing-customer/?${stringifiedParams}` : `/api/payments/invoicing-customer/`
}

export const paymentsInvoicingCustomerRetrieve = async (params?: PaymentsInvoicingCustomerRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<InvoicingCustomer> => {

  return customFetch<InvoicingCustomer>(getPaymentsInvoicingCustomerRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPaymentsInvoicingCustomerRetrieveQueryKey = (params?: PaymentsInvoicingCustomerRetrieveParams,) => {
    return [
    `/api/payments/invoicing-customer/`, ...(params ? [params] : [])
    ] as const;
    }


export const getPaymentsInvoicingCustomerRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof paymentsInvoicingCustomerRetrieve>>, TError = void>(params?: PaymentsInvoicingCustomerRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentsInvoicingCustomerRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPaymentsInvoicingCustomerRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof paymentsInvoicingCustomerRetrieve>>> = ({ signal }) => paymentsInvoicingCustomerRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof paymentsInvoicingCustomerRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PaymentsInvoicingCustomerRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof paymentsInvoicingCustomerRetrieve>>>
export type PaymentsInvoicingCustomerRetrieveQueryError = void


export function usePaymentsInvoicingCustomerRetrieve<TData = Awaited<ReturnType<typeof paymentsInvoicingCustomerRetrieve>>, TError = void>(
 params: undefined |  PaymentsInvoicingCustomerRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentsInvoicingCustomerRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof paymentsInvoicingCustomerRetrieve>>,
          TError,
          Awaited<ReturnType<typeof paymentsInvoicingCustomerRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentsInvoicingCustomerRetrieve<TData = Awaited<ReturnType<typeof paymentsInvoicingCustomerRetrieve>>, TError = void>(
 params?: PaymentsInvoicingCustomerRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentsInvoicingCustomerRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof paymentsInvoicingCustomerRetrieve>>,
          TError,
          Awaited<ReturnType<typeof paymentsInvoicingCustomerRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentsInvoicingCustomerRetrieve<TData = Awaited<ReturnType<typeof paymentsInvoicingCustomerRetrieve>>, TError = void>(
 params?: PaymentsInvoicingCustomerRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentsInvoicingCustomerRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePaymentsInvoicingCustomerRetrieve<TData = Awaited<ReturnType<typeof paymentsInvoicingCustomerRetrieve>>, TError = void>(
 params?: PaymentsInvoicingCustomerRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentsInvoicingCustomerRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPaymentsInvoicingCustomerRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPaymentsInvoicingCustomerUpdateUrl = (params?: PaymentsInvoicingCustomerUpdateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/payments/invoicing-customer/?${stringifiedParams}` : `/api/payments/invoicing-customer/`
}

/**
 * GigPro admins only. Points the organization's or location's invoicing settings at another Invoiced.com customer, after checking the id is not blank, is not already assigned to another organization or location, and exists on Invoiced.com — in that order. Nothing is saved unless every check passes. Re-sending the stored id is a no-op that does not call Invoiced.com. Every error `message` is written for display to the admin.
 * @summary Set the Invoiced.com customer id
 */
export const paymentsInvoicingCustomerUpdate = async (invoicedCustomerIdUpdateRequest?: InvoicedCustomerIdUpdateRequest,
    params?: PaymentsInvoicingCustomerUpdateParams, options?: Parameters<typeof customFetch>[1]): Promise<InvoicedCustomerId> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<InvoicedCustomerId>(getPaymentsInvoicingCustomerUpdateUrl(params),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(invoicedCustomerIdUpdateRequest)
  }
);}





export const getPaymentsInvoicingCustomerUpdateMutationKey = () => ['paymentsInvoicingCustomerUpdate'] as const;

export const getPaymentsInvoicingCustomerUpdateMutationOptions = <TError = CustomValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError | ConflictError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentsInvoicingCustomerUpdate>>, TError,PaymentsInvoicingCustomerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof paymentsInvoicingCustomerUpdate>>, TError,PaymentsInvoicingCustomerUpdateMutationVariables, TContext> => {

const mutationKey = getPaymentsInvoicingCustomerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof paymentsInvoicingCustomerUpdate>>, PaymentsInvoicingCustomerUpdateMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  paymentsInvoicingCustomerUpdate(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PaymentsInvoicingCustomerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof paymentsInvoicingCustomerUpdate>>>
    export type PaymentsInvoicingCustomerUpdateMutationBody = InvoicedCustomerIdUpdateRequest | undefined
    export type PaymentsInvoicingCustomerUpdateMutationError = CustomValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError | ConflictError
    export type PaymentsInvoicingCustomerUpdateMutationVariables = {data?: InvoicedCustomerIdUpdateRequest;params?: PaymentsInvoicingCustomerUpdateParams}

    /**
 * @summary Set the Invoiced.com customer id
 */
export const usePaymentsInvoicingCustomerUpdate = <TError = CustomValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError | ConflictError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentsInvoicingCustomerUpdate>>, TError,PaymentsInvoicingCustomerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof paymentsInvoicingCustomerUpdate>>,
        TError,
        PaymentsInvoicingCustomerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getPaymentsInvoicingCustomerUpdateMutationOptions(options), queryClient);
    }
